export default "__VITE_ASSET__CEQEpxPm__"